import React, { useCallback, useEffect, useId, useState } from "react";
import {
  evaluateTripMasterAccessPassword,
  notifyTripMasterAccessUnlocked,
  persistTripMasterAccessUnlocked,
  shouldBlockTripMasterAccess,
  TRIPMASTER_ACCESS_UNLOCKED_EVENT,
} from "./tripMasterAccessLogic";
import "./TripMasterAccessGate.scss";

export default function TripMasterAccessGate({
  children,
  hostname,
  storage,
} = {}) {
  const inputId = useId();
  const [unlocked, setUnlocked] = useState(
    () => !shouldBlockTripMasterAccess({ hostname, storage })
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const sync = () => {
      setUnlocked(!shouldBlockTripMasterAccess({ hostname, storage }));
    };
    window.addEventListener(TRIPMASTER_ACCESS_UNLOCKED_EVENT, sync);
    return () => window.removeEventListener(TRIPMASTER_ACCESS_UNLOCKED_EVENT, sync);
  }, [hostname, storage]);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      if (!evaluateTripMasterAccessPassword(password)) {
        setError("סיסמה שגויה");
        return;
      }
      persistTripMasterAccessUnlocked(storage);
      setError("");
      setUnlocked(true);
      notifyTripMasterAccessUnlocked();
    },
    [password, storage]
  );

  if (unlocked) return children;

  return (
    <div className="tm-access-gate" role="presentation">
      <div
        className="tm-access-gate__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={`${inputId}-title`}
      >
        <p className="tm-access-gate__brand">TripMaster</p>
        <h1 className="tm-access-gate__title" id={`${inputId}-title`}>
          האתר בתיקונים
        </h1>
        <p className="tm-access-gate__copy">כדי להיכנס הזינו את הסיסמה</p>
        <form className="tm-access-gate__form" onSubmit={handleSubmit}>
          <label className="tm-access-gate__label" htmlFor={inputId}>
            סיסמה
          </label>
          <input
            id={inputId}
            className="tm-access-gate__input"
            type="password"
            name="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              if (error) setError("");
            }}
          />
          {error ? (
            <p className="tm-access-gate__error" role="alert">
              {error}
            </p>
          ) : null}
          <button className="tm-access-gate__submit" type="submit">
            כניסה
          </button>
        </form>
      </div>
    </div>
  );
}
